export function emailDeleteHTML(fromEmail, fromName, reloadYardName) {
  return `<!-- Begin HTML Content -->
        <br>
        ${fromName} has removed your access to ${reloadYardName} on transloads.co <br/>
        If you believe this was done by mistake, please contact ${fromName} at the following email address: <br/>
        ${fromEmail} <br/>
        <br/>
        <hr style="border-bottom:#CCCCCC 6px dotted; border-width: 0 0 6px 0;">
        <br>
        If we can be of service to you, please don't hesitate to contact us at:<br/>
        <a href="mailto:support@transloads.co">support@transloads.co</a> <br/>
        or <br/>
        (877) TRANSLOAD / (877) 872-6756
        <br/>
        <!-- End HTML Content -->`;
}
